import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    banner: [
      "relative",
      "w-full py-3 px-6 ",
      "h-[140px] md:h-[130px] lg:h-[100px] lg:p-4",
      "flex flex-col items-start gap-2",
      "lg:flex lg:flex-row lg:justify-end lg:items-center lg:gap-10",
      "xl:justify-center xl:items-center xl:gap-10",
      "bg-[url('/assets/banners/banner-marketplace-dash-mobile.png')]",
      "lg:bg-[url('/assets/banners/banner-marketplace-dash.png')] bg-cover",
    ],
    bannerData: "max-w-[305px] flex flex-col justify-center items-start",
    bannerTitle: "!text-white mobile:!text-[16px] lg:max-w-full leading-[24px]",
    bannerDescription: "hidden md:block !text-foreground-300 dark:!text-foreground-700",
    bannerButton: "w-[120px] mobile:w-auto mobile:h-[40px]",
    closeButton: "absolute md:hidden rounded-full cursor-pointer bg-white p-px mobile:top-4 mobile:right-4",
    closeIcon: "w-4 h-4 text-black",
  },
  variants: {
    display: {
      false: {
        banner: "!hidden",
      },
    },
  },
});
